import { en } from './en';
import { fr } from './fr';
import type { PreviewDictionary, PreviewLanguage } from './types';

const dictionaries: Record<PreviewLanguage, PreviewDictionary> = {
    en,
    fr,
};

/**
 * Pure dictionary lookup. Kept independent from React so it can be used
 * outside a render pass (e.g. in Formik validation messages or in tests)
 * and so the i18n module doesn't depend on the preview context.
 *
 * The hook flavour (`useT`) lives next to the PreviewContext and reads
 * the active language from there.
 */
export const getDictionary = (language: PreviewLanguage): PreviewDictionary =>
    dictionaries[language];
